import { Extension } from '@tiptap/core';

const MAX_INDENT = 6;

const INDENTABLE = new Set(['paragraph', 'heading', 'blockquote', 'valueRow', 'taskList', 'bulletList', 'orderedList', 'codeBlock', 'horizontalRule']);

function findTopBlocks(state) {
  const { $from, $to } = state.selection;
  const blocks = new Map();

  for (const $pos of [$from, $to]) {
    for (let d = 1; d <= $pos.depth; d++) {
      const node = $pos.node(d);
      if (INDENTABLE.has(node.type.name)) {
        const pos = $pos.before(d);
        if (!blocks.has(pos)) blocks.set(pos, node);
        break;
      }
    }
  }

  return blocks;
}

export const Indent = Extension.create({
  name: 'indent',

  addGlobalAttributes() {
    return [{
      types: [...INDENTABLE],
      attributes: {
        indent: {
          default: 0,
          parseHTML: el => parseInt(el.getAttribute('data-indent'), 10) || 0,
          renderHTML: attrs => {
            if (!attrs.indent) return {};
            return {
              'data-indent': attrs.indent,
              style: `margin-left: ${attrs.indent * 24}px`,
            };
          },
        },
      },
    }];
  },

  addCommands() {
    return {
      indent: () => ({ tr, state, dispatch }) => {
        const blocks = findTopBlocks(state);
        if (blocks.size === 0) return false;
        let changed = false;
        for (const [pos, node] of blocks) {
          if (node.attrs.indent >= MAX_INDENT) continue;
          if (dispatch) tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: node.attrs.indent + 1 });
          changed = true;
        }
        return changed;
      },
      outdent: () => ({ tr, state, dispatch }) => {
        const blocks = findTopBlocks(state);
        if (blocks.size === 0) return false;
        let changed = false;
        for (const [pos, node] of blocks) {
          if (node.attrs.indent <= 0) continue;
          if (dispatch) tr.setNodeMarkup(pos, undefined, { ...node.attrs, indent: node.attrs.indent - 1 });
          changed = true;
        }
        return changed;
      },
    };
  },
});
